import React from 'react'
import * as Icons from 'ui/icons'
import * as Displays from 'support/displays'
import { observer } from 'mobx-react'
import { useValue } from '@morningtrain/react-resources'
import * as UI from 'ui'

export function ChecklistName () {
  const isCompleted = useValue('fill_percentage') === 100
  const completedClass = isCompleted ? 'text-primary-500' : 'text-gray-400'

  return (
    <div className='flex items-center text-primary-900'>
      <Icons.CheckmarkCircle className={['w-4 h-4 mr-2', completedClass].join(' ')} />
      <UI.Text truncate block className='w-48'>
        <Displays.Text name='name' />
      </UI.Text>
    </div>
  )
}

export default observer(ChecklistName)
